'use strict';

const password = [
  '$q',
  '$http',
  'userModel',
  'auth',
  'utils',

  function ($q, $http, userModel, auth, utils) {
    return {
      verifyPasswordResetParams: function (params) {
        return new $q(function (resolve, reject) {
          var requestOptions = {
            params: params
          };

          return $http.get(utils.getApiUrl('reset_password/reset'), requestOptions)
            .then(resolve)
            .catch(reject);
        });
      },
      resetPassword: function (data, params) {
        return new $q(function (resolve, reject) {
          var requestOptions = {
            params: params
          };

          return $http.post(utils.getApiUrl('reset_password/reset'), data, requestOptions)
            .then(resolve)
            .catch(reject);
        });
      },

      changePassword: function (data) {
        return new $q(function (resolve, reject) {
          return $http.post(utils.getApiUrl('settings/' + userModel.item.id + '/password'), data)
            .then(function (response) {
              var responseData = response.data;

              auth.setSessionData({
                accessToken: responseData.token,
                userId: userModel.item.id
              });
              resolve();
            })
            .catch(reject);
        });
      }
    };
  }
];

export default password;



// WEBPACK FOOTER //
// ./app/src/services/password.js